import type { ModuloWeb } from '../../nucleo/modulos-web';
import { Api } from './Api';
import { Conectores } from './Conectores';
import { ContaAzul } from './ContaAzul';
import { Mcp } from './Mcp';
import { Webhooks } from './Webhooks';
import { i18n } from './i18n';

/** M14.7: quatro abas, na ordem da especificação. Ver tudo exige `integracoes.ver`; as ações exigem a permissão da aba. */
const modulo: ModuloWeb = {
  slug: 'integracoes',
  menu: 'integracoes',
  ordem: 90,
  abas: [
    { chave: 'conectores', permissao: 'integracoes.ver', componente: Conectores },
    { chave: 'webhooks', permissao: 'integracoes.ver', componente: Webhooks },
    { chave: 'api', permissao: 'integracoes.ver', componente: Api },
    { chave: 'mcp', permissao: 'integracoes.ver', componente: Mcp },
    // Trilha Conta Azul (13/10): espelho só leitura, comparação e conversor para os importadores existentes.
    { chave: 'conta-azul', permissao: 'integracoes.ver', componente: ContaAzul },
  ],
  i18n,
};

export default modulo;
